<template>
  <div>
    <div class="font-bold d-flex justify-content-between">
      <div>Job Efficiency:</div>
      <tooltip
        placement="top"
        :disabled="Boolean(job.job_efficiency_pct) && job.job_times_valid"
      >
        <template #trigger>
          <div>{{ jobEfficiency }}</div>
        </template>
        <template #tooltip>
          <div>{{ jobEfficiencyTooltip }}</div>
        </template>
      </tooltip>
    </div>
    <div class="times-container">
      <div class="time-display">
        Pre-Work:
        <minutes-label
          :minutes="job.pre_work_minutes"
          :not-available="!job.job_times_valid"
          :default-text="missingDataTooltip"
          :not-available-text="notAvailableTooltip"
        />
      </div>
      <div class="time-display">
        Travel:
        <minutes-label
          :minutes="job.travel_minutes"
          :not-available="!job.job_times_valid"
          :default-text="missingDataTooltip"
          :not-available-text="notAvailableTooltip"
        />
      </div>
      <div class="mb-2 time-display">
        Work:
        <minutes-label
          :minutes="job.work_minutes"
          :not-available="!job.job_times_valid"
          :default-text="missingDataTooltip"
          :not-available-text="notAvailableTooltip"
        />
      </div>
      <div class="time-display">
        <b>Total:</b>
        <minutes-label
          :minutes="job.total_minutes"
          :not-available="!job.job_times_valid"
          :default-text="missingDataTooltip"
          :not-available-text="notAvailableTooltip"
        />
      </div>
      <div class="time-display">
        <b>Sold:</b>
        <div class="d-flex">
          <span v-if="job.sold_minutes && job.job_times_valid" class="mr-2"
            >-</span
          >
          <minutes-label
            :class="{ 'minutes-border': job.sold_minutes }"
            :minutes="job.sold_minutes"
            :not-available="!job.job_times_valid"
            :default-text="missingDataTooltip"
            :not-available-text="notAvailableTooltip"
          />
        </div>
      </div>
      <job-times-result-label
        :minutes="resultTime"
        :not-available="!job.job_times_valid"
        :default-text="missingDataTooltip"
        :not-available-text="notAvailableTooltip"
        class="time-display font-bold"
        colon
      ></job-times-result-label>
      <div class="link" @click="activateJobTimesTab">View Breakdown</div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

import FeatureFlag from "@/components/FeatureFlag.vue";
import MinutesLabel from "@/components/MinutesLabel.vue";
import Tooltip from "@/components/Tooltip.vue";
import CONSTANTS from "@/Constants.js";
import JobTimesResultLabel from "@/Job/JobTimesResultLabel.vue";
const { NO_JOB_TIME_TOOLTIP_TEXT, NOT_AVAILABLE_JOB_TIME_TOOLTIP_TEXT } =
  CONSTANTS;

export default {
  components: {
    FeatureFlag,
    MinutesLabel,
    JobTimesResultLabel,
    Tooltip
  },
  props: {
    job: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    resultTime() {
      const { total_minutes, sold_minutes } = this.job;
      return !total_minutes && !sold_minutes
        ? null
        : (total_minutes || 0) - (sold_minutes || 0);
    },
    jobEfficiency() {
      const { job_efficiency_pct, job_times_valid } = this.job;
      if (!job_times_valid) {
        return "N/A";
      }
      return job_efficiency_pct ? `${job_efficiency_pct}%` : "--";
    },
    jobEfficiencyTooltip() {
      if (this.jobEfficiency === "--") {
        return NO_JOB_TIME_TOOLTIP_TEXT;
      }
      if (this.jobEfficiency === "N/A") {
        return NOT_AVAILABLE_JOB_TIME_TOOLTIP_TEXT;
      }
      return "";
    },
    missingDataTooltip() {
      return NO_JOB_TIME_TOOLTIP_TEXT;
    },
    notAvailableTooltip() {
      return NOT_AVAILABLE_JOB_TIME_TOOLTIP_TEXT;
    }
  },
  methods: {
    activateJobTimesTab() {
      EventBus.$emit("set-selected-tab", "Job Times");
    }
  }
};
</script>

<style lang="scss" scoped>
.time-display {
  display: flex;
  justify-content: space-between;
}

.times-container {
  min-width: 140px;
}

.minutes-border {
  border-bottom: 1px solid var(--gray-border-color);
}
</style>
